import {AfterViewInit, Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AbstractControl, ControlValueAccessor, NG_VALUE_ACCESSOR, NgModel} from '@angular/forms';





@Component({
  selector: 'app-input-custom',
  templateUrl: './input-custom.component.html',
  styleUrls: ['./input-custom.component.scss'],
  providers: [ {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputCustomComponent),
    multi: true
  } ]
})




  export class InputCustomComponent implements ControlValueAccessor, OnInit, AfterViewInit  {



  @ViewChild('input') input: any;
  @Input('name')  _name: string;
  @Input('label')  _label: string;
  @Input('placeholder')  private _placeholder: string;
  @Input('disabled') private _disabled = false;
  @Input('readonly') private _readonly = false;
  @Input('control') private control: AbstractControl;
  @Input('value') private _value: string;
  @Input('type') private _type = 'text';
  @Output('onBlur') onBlur = new EventEmitter()
  @Input('focus') private _focus: false;




  private propagateChange: Function;
  private onTouched: Function;
  private _isError: boolean;
  private _isRequired: boolean;
  private _isTouch = false;
  private _isChanged = false;
  private _messageError: string;
  constructor() {}

  ngAfterViewInit(): void {
    if (!this.name) {
      throw new Error('Inserire un nome alla Input [name]');
    }

    this.registerOnChange(() => {
      this._isError = false;
      this._messageError = '';
      this._isTouch = true;
      this.control.setValue(this.input.nativeElement.value)
      if (this._value !== this.control.value) {
        this._isChanged = true;
      }
      if (this.control.invalid) {
        this._isError = true;
          if (this.isRequired && !this.control.errors.err) {
              this._messageError = 'Campo Obbligatorio';
          } else {
            this._messageError = this.control.errors.err;
          }
        this.onBlur.emit({obj: this, value: this.control.value, err: this._isError });

      } else {
        this._isError = false;
        this.onBlur.emit({obj: this, value: this.control.value, err: this._isError });
      }
    });
  }

  hasRequiredField(abstractControl: AbstractControl): boolean {
    if (abstractControl.validator) {
      const validator = abstractControl.validator({}as AbstractControl);
      if (validator && validator.required) {
        return true;
      }
    }
  }

  ngOnInit(): void {
    this._isRequired = this.hasRequiredField(this.control);
    this.value = this._value;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }

  writeValue(obj: any): void {
   // this.control.setValue(obj);
    this.input.nativeElement.value = obj;
  }
  change( $event ) {
    this.propagateChange($event.target);
  }
  // <editor-fold desc="SET GETTER">
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get label(): string {
    return this._label;
  }
  set label(value: string) {
    this._label = value;
  }
  get placeholder(): string {
    return this._placeholder;
  }
  set placeholder(value: string) {
    this._placeholder = value;
  }
  get value(): string {
    return this.control.value;
  }
  set value(value: string) {
    this.control.setValue(value);
    this._value = value;
  }
  get isError(): boolean {
    return this._isError;
  }
  get isRequired(): boolean {
      return this._isRequired;
  }
  get isTouch(): boolean {
    return this._isTouch;
  }
  get isChanged(): boolean {
    return this._isChanged;
  }
  get messageError(): string {
    return this._messageError;
  }
  get readonly(): boolean {
    return this._readonly;
  }
  get disabled(): boolean {
    return this._disabled;
  }
  get type(): string {
    return this._type;
  }
  // </editor-fold>
  set focus(value: false) {
    if (value && !this._focus) {
      this.input.nativeElement.focus();
    }
    this._focus = value
  }
  set disabled(value: boolean) {
    this._disabled = value;
    this.setDisabledState(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/component/input-custom/input-custom.component.ts